import ClipWebFlyer from "../assets/images/cw-flyer.png";

const cw_flyer = {
    slug: "Clip_Web_Flyer_Digital",
    sections: [
        {
            elements: [
                { type: "title-prc", content: "Clip Web - Ma freelance" },
                { type: "tex-prc", content: "Création complète de mon identité de freelance : site web, charte graphique, logo et supports de communication digitaux." },
                { type: "imageTitle", src: ClipWebFlyer, alt: "Flyer numérique Clip Web" }
            ]
        },
        {
            elements: [
                { type: "title", content: "Présentation du projet" },
                { type: "text", content: "Clip Web est ma propre activité de freelance en développement web et design graphique. Ce projet personnel m'a permis de mettre en pratique l'ensemble de mes compétences pour créer une identité professionnelle complète, du concept initial à la promotion en ligne." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Phase de conception" },
                { type: "text", content: "Le projet a débuté par une phase de réflexion approfondie sur mon positionnement et mon identité visuelle. J'ai créé des maquettes pour le site web, développé une charte graphique cohérente, et conçu un logo qui reflète mon approche du design : moderne, épuré et professionnel. Cette étape de conception a été essentielle pour établir une base solide." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Développement du site web" },
                { type: "text", content: "Le site web Clip Web a été développé avec React, en mettant l'accent sur la performance, le responsive design et l'expérience utilisateur. Chaque section a été pensée pour présenter mes services de manière claire et attractive. Le site intègre des animations subtiles et une navigation intuitive pour guider les visiteurs." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Référencement et visibilité" },
                { type: "text", content: "Une attention particulière a été portée au référencement naturel (SEO) pour assurer la visibilité du site sur les moteurs de recherche. J'ai optimisé la structure du code, les balises meta, les temps de chargement et le contenu textuel. Cette stratégie SEO permet à Clip Web d'apparaître dans les résultats de recherche pour des requêtes pertinentes." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Promotion sur les réseaux sociaux" },
                { type: "text", content: "Pour développer ma visibilité, j'ai mis en place une stratégie de communication sur les réseaux sociaux professionnels (LinkedIn, Facebook). Le site a été partagé via mon réseau, accompagné de contenus mettant en avant mes réalisations et mon expertise. Cette approche multicanale a permis de toucher différents publics cibles." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Création du flyer numérique" },
                { type: "text", content: "Pour compléter ma présence en ligne, j'ai conçu un flyer numérique synthétique et impactant. Ce support digital permet de présenter rapidement mes services en quelques lignes, avec un visuel attractif et des informations essentielles. Le format numérique facilite le partage par email, sur les réseaux sociaux ou lors d'échanges professionnels, sans nécessiter d'impression." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Résultat" },
                { type: "text", content: "Clip Web dispose aujourd'hui d'une identité visuelle forte et cohérente, d'un site web professionnel et performant, et d'outils de communication efficaces. Cette présence digitale complète me permet de présenter mes services, d'attirer des clients potentiels et de développer mon activité de freelance." }
            ]
        }
    ]
};

export default cw_flyer;